import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/album/importer/albumImporterActions'

export default importerReducers(actions)
